import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import AddCardPopup from 'web/components/AddCardPopup';
import { fetchLanguageContentNew } from "redux/actions/language";

const customStyles = {
  control: (provided) => ({
    ...provided,
    fontSize: '13px',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '13px',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '13px',
  }),
};

export default ({ paymentDetails, callBackPageDataApi, paymentPageStateValues, setPaymentPageStateValuesCallback }) => {
  const dispatch = useDispatch();
  const [cardDetailsList, setCardDetailsList] = useState()
  const [achCardsList, setAchCardsList] = useState()
  const [achBackUpCardDetailsList, setAchBackUpCardDetailsList] = useState()

  const [addCardmodal, setAddCardmodal] = useState(false);
  const addCardToggleModal = () => setAddCardmodal(!addCardmodal);

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();
  useEffect(() => {
    if (languageContentNew?.H8_Nav_Payment_Page) setPageLanguageContents(languageContentNew.H8_Nav_Payment_Page);
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew]);

  useEffect(() => {
    setPaymentDetailsFunc()
  }, [paymentDetails])

  const setPaymentDetailsFunc = () => {
    let cardDetailsListTemp = [], achAccountDetailsTemp
    let paymentDetailsTemp = paymentDetails
    if (paymentDetailsTemp?.cardDetails?.length > 0) {
      cardDetailsListTemp = paymentDetailsTemp?.cardDetails?.map(data => {
        if (data.defaultPayment) {
          setPaymentPageStateValuesCallback('selectedPaymentOption', data.id)
          setPaymentPageStateValuesCallback('paymentMethod', data.paymentMethod)
          setPaymentPageStateValuesCallback('isAchSelected', false)
          setPaymentPageStateValuesCallback('achBackUpCard', null)
        }
        return (
          {
            value: data.id,
            label: `${data.brandName?.charAt(0).toUpperCase() + data.brandName.slice(1)} ending in ${data.last4Digit}, expires ${data.expMonth}/${data.expYear}`,
            defaultPayment: data.defaultPayment,
            type: data.paymentMethod
          }
        )
      })
      setAchBackUpCardDetailsList([...cardDetailsListTemp])
    }
    if (paymentDetailsTemp?.achDetails?.length > 0) {
      achAccountDetailsTemp = paymentDetailsTemp?.achDetails?.map(data => {
        if (data.defaultPayment) {
          setPaymentPageStateValuesCallback('selectedPaymentOption', data.id)
          setPaymentPageStateValuesCallback('isAchSelected', true)
          setPaymentPageStateValuesCallback('paymentMethod', data.paymentMethod)
        }
        return (
          {
            value: data.id,
            label: 'Account Number: ******' + data.last4Digit + ' Bank Routing Number: ******' + data.routingNumber,
            type: data.paymentMethod,
            defaultPayment: data.defaultPayment
          }
        )
      })
      if (achAccountDetailsTemp) {
        setAchCardsList(achAccountDetailsTemp)
        cardDetailsListTemp.push(achAccountDetailsTemp)
      }
    }
    if (cardDetailsListTemp) setCardDetailsList(cardDetailsListTemp.flat())
  }

  return (
    <div className='payment-section-wrapper'>
      <div>
        {cardDetailsList ? <>
          {cardDetailsList && cardDetailsList.map((value, index) => (
            <div key={index}>
              <label style={{ display: 'flex', marginBottom: '20px', fontSize: '13px' }}>
                <input
                  className='radio-button-styles'
                  type="radio"
                  id="selectedPaymentOption"
                  name="cardTypeRadio"
                  value={value.value}
                  checked={paymentPageStateValues.selectedPaymentOption === value.value}
                  onChange={(e) => {
                    setPaymentPageStateValuesCallback('selectedPaymentOption', e.target.value)
                    let paymentOptionTemp = cardDetailsList.filter(data => data.value === e.target.value)
                    if (paymentOptionTemp && paymentOptionTemp?.length > 0) setPaymentPageStateValuesCallback('paymentMethod', paymentOptionTemp[0].type)
                    if (achCardsList?.filter(val => val.value === e.target.value).length > 0) {
                      setPaymentPageStateValuesCallback('isAchSelected', true)
                    } else {
                      setPaymentPageStateValuesCallback('isAchSelected', false)
                      setPaymentPageStateValuesCallback('achBackUpCard', null)
                    }
                  }}
                />
                {value.label}
              </label>
            </div>
          ))}
        </> : ''}
      </div>
      {paymentPageStateValues?.isAchSelected &&
        <div className='ach-backup-section-styles'>
          <p style={{ fontSize: '13px' }}>Select a backup card for ACH*</p>
          <Select
            id="achBackUpCard"
            name='achBackUpCard'
            value={paymentPageStateValues?.achBackUpCard}
            onChange={(data) => setPaymentPageStateValuesCallback('achBackUpCard', data)}
            options={achBackUpCardDetailsList}
            placeholder="Select a card*"
            styles={customStyles}
          />
        </div>
      }
      <div>
        <label style={{ display: 'flex', fontSize: '13px' }}>
          <input
            type="radio"
            className='radio-button-styles'
            id="selectedPaymentOption"
            name="cardTypeRadio"
            value={'newCard'}
            checked={false}
            onChange={(e) => {
              addCardToggleModal()
            }}
          />
          Add Payment Details
        </label>
      </div>

      <AddCardPopup
        isOpen={addCardmodal}
        toggle={addCardToggleModal}
        title=''
        response=''
        individual={(cardDetailsList && cardDetailsList?.length > 0) ? '' : 'Individual'}
        callBackModal={() => {
          addCardToggleModal();
        }}
        callBackFetchApi={() => {
          callBackPageDataApi()
          addCardToggleModal()
        }}
        onClickHander={(val) => {
        }}
        content=""
        link=''
        pageLanguageContents={pageLanguageContents}
      />
    </div>
  );
};
